module.exports = __webpack_public_path__ + "static/media/stripe-badge.67efa184.png";